var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 7,
    fill: "#0010F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1677 15.44C31.1026 15.14 30.6375 15.095 30.6375 15.095C30.4575 15.065 29.7523 14.945 28.7922 14.915C28.0271 14.795 27.2319 14.585 26.7068 14.15C26.1367 13.67 25.1766 12.845 24.8015 12.65C24.7865 12.635 24.7715 12.635 24.7565 12.635C23.3163 11.6 21.561 11 19.6707 11C17.5103 11 15.545 11.765 14.0148 13.04C13.5797 13.37 13.0546 13.82 12.6945 14.135C12.1695 14.585 11.3743 14.78 10.6092 14.9C9.64905 14.93 8.94393 15.065 8.7639 15.08C8.7639 15.08 8.34384 15.125 7.35367 15.395C6.9186 15.515 6.8736 16.115 7.27866 16.31C7.27866 16.31 7.29366 16.31 7.29366 16.325C7.93877 16.64 8.55387 17.15 9.319 18.365C10.2341 19.805 10.3992 20.72 10.9843 22.1C11.9294 26.06 15.455 29 19.6557 29C23.7064 29 27.1269 26.27 28.2221 22.535C28.9722 20.9 29.0772 19.955 30.0824 18.365C30.8475 17.15 31.4626 16.64 32.1077 16.325C32.1527 16.31 32.1977 16.28 32.2427 16.265C32.6178 16.1 32.5728 15.545 32.1677 15.44ZM16.2351 22.37C15.0349 22.04 14.2848 20.93 14.2848 20.93C14.2848 20.93 15.575 19.985 16.7752 20.315C17.9754 20.645 18.6355 22.115 18.6355 22.115C18.6355 22.115 17.4353 22.7 16.2351 22.37ZM23.3763 22.37C22.1761 22.7 20.9759 22.1 20.9759 22.1C20.9759 22.1 21.621 20.63 22.8362 20.3C24.0364 19.97 25.3266 20.915 25.3266 20.915C25.3266 20.915 24.5765 22.055 23.3763 22.37Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.548134fbe47163c78dcf04dbb81574e8.svg";
export { ForwardRef as ReactComponent };